<div class="row mt-1 table-row">
    <div class="col-md-2" hznTestId="discount-type">{{ translateType(form.controls.type.value) }}</div>
    <div class="col-md-2" hznTestId="discount-name">{{ form.controls.name.value }}</div>
    <div class="col-md-4" hznTestId="discount-details">
        @if (isSiblings) {
            <div>
                {{ discountDetailsLabel() }}
                {{ form.controls.minimumNumberOfDays.value }} -
                {{ form.controls.maximumNumberOfDays.value || "&infin;" }}
            </div>
        }
        @if (isEarlyBird) {
            <div>
                {{ discountDetailsLabel() }}
                {{ form.controls.dateFrom.value | bcDate }} -
                {{ form.controls.dateTo.value | bcDate }}
            </div>
        }
        @if (isTier) {
            <div>
                {{ discountDetailsLabel() }}
                {{ translateTier(form.controls.membershipTier.value) }}
            </div>
        }
        @if (isNumberOfDays) {
            <div>
                {{ discountDetailsLabel() }}
                {{ form.controls.daysFrom.value }} -
                {{ form.controls.daysTo.value }}
            </div>
        }

        @if (isEnrollmentDays) {
            <div>
                {{ discountDetailsLabel() }}
                {{ form.controls.dateFrom.value | bcDate }} -
                {{ form.controls.dateTo.value | bcDate }}
            </div>
        }
        @if (isPif) {
            <div>
                {{ discountDetailsLabel() }}
                {{ form.controls.minimumNumberOfCamps.value }}
            </div>
        }
    </div>
    @if (form.controls.isCartLevel.value) {
        <div class="col-md-1 text-center">
            {{ form.controls.applicationOrder.value }}
        </div>
    }
    <div
        [ngClass]="{
            'col-md-1': form.controls.isCartLevel.value,
            'col-md-2': form.controls.isPricingLevel.value,
        }"
        class="text-center"
        hznTestId="discount-value"
    >
        {{ form.controls.valuePercent.value }}%
    </div>
    <div class="col-md-2">
        @if (state.canEdit | async) {
            <button
                class="btn btn-action btn-primary pull-right"
                [disabled]="isOtherItemEdited"
                bcClick
                hznTestId="discount-edit"
                (clicked)="edit()"
            >
                {{ "General.Edit" | translate }}
            </button>
        }
        @if (state.canEdit | async) {
            <button
                class="btn btn-danger btn-action pull-right mr-1"
                [disabled]="isOtherItemEdited"
                bcClick
                hznTestId="discount-remove"
                (clicked)="remove()"
            >
                {{ "General.Remove" | translate }}
            </button>
        }
    </div>
</div>
